module.exports = __webpack_public_path__ + "img/gracias_ 536x354.198f08ec.jpg";